/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { adDesignShowDefaults } from '../../axios/adDesignShowDefaults'
import type {
	AdDesignShowDefaultsError,
	AdDesignShowDefaultsPathParams,
	AdDesignShowDefaultsResponse,
} from '../../types/AdDesignShowDefaults'

export const adDesignShowDefaultsQueryKey = (organisation: AdDesignShowDefaultsPathParams['organisation']) =>
	[{ url: '/organisations/:organisation/default-designs', params: { organisation } }] as const

export type AdDesignShowDefaultsQueryKey = ReturnType<typeof adDesignShowDefaultsQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::showDefaults */
export function adDesignShowDefaultsQueryOptions(
	organisation: AdDesignShowDefaultsPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AdDesignShowDefaultsResponse,
		AxiosError<AdDesignShowDefaultsError>,
		AdDesignShowDefaultsResponse,
		AdDesignShowDefaultsQueryKey
	>({
		queryKey: adDesignShowDefaultsQueryKey(organisation),
		queryFn: ({ signal }) => adDesignShowDefaults(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::showDefaults */
export function useAdDesignShowDefaults<TSelectData = AdDesignShowDefaultsResponse>(
	organisation: AdDesignShowDefaultsPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AdDesignShowDefaultsResponse,
					AxiosError<AdDesignShowDefaultsError>,
					TSelectData,
					AdDesignShowDefaultsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AdDesignShowDefaultsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...adDesignShowDefaultsQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::showDefaults */
export function useAdDesignShowDefaultsSuspense<TSelectData = AdDesignShowDefaultsResponse>(
	organisation: AdDesignShowDefaultsPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AdDesignShowDefaultsResponse,
					AxiosError<AdDesignShowDefaultsError>,
					TSelectData,
					AdDesignShowDefaultsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AdDesignShowDefaultsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...adDesignShowDefaultsQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
